import React, { useEffect, useState } from 'react';
import './reports.css';
import { DownloadPdfButton, Loader, Modal } from '../../components';
import { getAnalyticsData, getReports } from '../../service/reports';
import { STRINGS } from '../../comman/constants';

export default function Report() {
  const [isLoading, setIsLoading] = useState(false);
  const [openReport, setOpenReport] = useState(false);
  const [reportData, setReportData] = useState({});
  const [enterSecureCode, setEnterSecureCode] = useState(false);
  const [secureCode, setSecureCode] = useState('');
  const [analyticsData, setAnalyticsData] = useState({});

  // ✅ Key → Title mapping
const titles = {
  improvedUsersWith75AdherencePercentage:
    "Patients who improved with more than 75% adherence",
  improvedUsersWith50AdherencePercentage:
    "Patients who improved with more than 50% adherence",
  improvedUsersWithoutdherencePercentage:
    "Patients who improved without considering adherence",

  improvedRadiatingAbove75AdherencePercentage:
    "Patients who improved in radiation pain with more than 75% adherence",
  improvedRadiatingAbove50AdherencePercentage:
    "Patients who improved in radiation pain with more than 50% adherence",
  improvedRadiatingWithoutAdherencePercentage:
    "Patients who improved in radiation pain without considering adherence",

  constantRadiatingAbove75AdherencePercentage:
    "Patients with constant radiation with more than 75% adherence",
  constantRadiatingAbove50AdherencePercentage:
    "Patients with constant radiation with more than 50% adherence",
  constantRadiatingWithoutAdherencePercentage:
    "Patients with constant radiation without considering adherence",
};



  const getReportData = async (secureCode) => {
    try {
      setIsLoading(true);
      const response = await getReports(secureCode);
      if (response.status === 200) {
        const responseData = response.data?.data || response.data;
        setReportData(responseData);
        setTimeout(() => setOpenReport(true), 500);
      } else {
        throw new Error(`Request failed with status ${response.status}`);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setTimeout(() => setOpenReport(true), 500);

    } finally {
      setIsLoading(false);
      setEnterSecureCode(false);
    }
  };

  useEffect(()=>{
    geAnalytics();
  },[])

  const geAnalytics = async () => {
    try {
      setIsLoading(true);
      const response = await getAnalyticsData();
      if (response.status === 200) {
        const responseData = response.data?.data || response.data;
        console.log(responseData);
        setAnalyticsData(responseData);
      } else {
        throw new Error(`Request failed with status ${response.status}`);
      }
    } catch (error) {
      console.error('Error fetching data:', error);

    } finally {
      setIsLoading(false);
      setEnterSecureCode(false);
    }
  };

  const Section = ({ title, items }) => {
    const entries = Object.entries(items || {}).filter(
      ([, value]) => value && String(value).trim() !== ""
    );
  
    return (
      <div className="section">
        <h2 className="section-title">{title}</h2>
        {entries.length > 0 ? (
          <div className="section-list">
            {entries.map(([key, value]) => (
              <div key={key} className="row">
                <span className="label">{titles[key] || key}</span>
                <span className="value">{value}%</span>
              </div>
            ))}
          </div>
        ) : (
          <p className="no-data">No data available</p>
        )}
      </div>
    );
  };

  return isLoading ? (
    <Loader/>
  ) : (
    <>
      <div style={{ padding: '20px'}}>
        <button
          onClick={() => getReportData()}
          className="report-button"
        >
          {STRINGS.reports.generateReport}
        </button>
        <button
          onClick={() => setEnterSecureCode(true)}
          className="report-button"
        >
          {STRINGS.reports.generateReportWithSecureCode}
        </button>
      </div>


      <div className="main-container">
      <Section title="Improved Users" items={analyticsData.improvedUsers} />
      <Section title="Patients with radiation Improved" items={analyticsData.raditionImproved} />
      <Section title="Patients with radiation constant" items={analyticsData.radiationConstant} />
      <div style={{height:"200px"}}></div>
    </div>
    



      {/* Modal to display generated report */}
      <Modal show={openReport} onClose={() => setOpenReport(false)}>
        <div className="modal-content">
          <DownloadPdfButton pdfData={reportData} />
        </div>
      </Modal>

      {/* Modal to enter secure code */}
      <Modal show={enterSecureCode} width="450px" onClose={() => setEnterSecureCode(false)}>
        <div className="modal-content">
          <input
            className="secure-code-input"
            type="text"
            placeholder={STRINGS.reports.enterSecureCode}
            value={secureCode}
            onChange={(e) => setSecureCode(e.target.value)}
          />
          <button
            onClick={() => getReportData(secureCode)}
            className="generate-secure-report-button"
          >
            {STRINGS.reports.generateReport}
          </button>
        </div>
      </Modal>
    </>
  );
}
